<h2 mat-dialog-title>Re-assign project owner</h2>

<mat-dialog-content class="dialog-body">
  <p>
    Project: <strong>{{ data.project.name }}</strong>
  </p>
  <p class="meta">
    Current owner: <strong>{{ data.project.created_by_name || '—' }}</strong>
  </p>
  <p class="hint">Search by name or email (min. 2 characters), select a user, then confirm.</p>

  <mat-form-field appearance="outline" class="full-width">
    <mat-label>New owner</mat-label>
    <input
      matInput
      [formControl]="searchControl"
      [matAutocomplete]="userAuto"
      placeholder="Type to search users"
    />
    <mat-autocomplete
      #userAuto="matAutocomplete"
      [displayWith]="displayUser"
      (optionSelected)="onUserSelected($event)"
    >
      @for (u of filteredUsers; track u.id) {
        <mat-option [value]="u">{{ u.full_name }} — {{ u.email }}</mat-option>
      }
    </mat-autocomplete>
  </mat-form-field>

  @if (selectedUser) {
    <p class="selected">
      Selected: <strong>{{ selectedUser.full_name }}</strong>
      <span class="email">({{ selectedUser.email }})</span>
    </p>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="close()" [disabled]="saving">Cancel</button>
  <button
    mat-flat-button
    color="primary"
    type="button"
    (click)="submit()"
    [disabled]="!selectedUser || saving"
  >
    @if (saving) {
      <span>Re-assigning…</span>
    } @else {
      <span>Re-assign</span>
    }
  </button>
</mat-dialog-actions>
